module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow@3-7389f295fefcfd6227cc6d4f6b8b386c.png";